module.exports = __webpack_public_path__ + "img/OnVista_icon.aeb1e5b3.png";